import { AuthClient } from "@/clients/auth_client";
import { AuthModule } from "@/store/auth";

export class AuthRepo {
  private static instance: AuthRepo;

  private constructor() {
    console.log("In Auth Repo");
    AuthClient.getInstance().signInAnonymous();
  }

  static getInstance(): AuthRepo {
    if (!AuthRepo.instance) {
      AuthRepo.instance = new AuthRepo();
    }

    return AuthRepo.instance;
  }

  getAuthClient(): AuthClient {
    return AuthClient.getInstance();
  }
}
